import FlexibleText from './FlexibleText'

export { FlexibleText }
